class SupabaseKey{
    REACT_APP_SUPABASE_URL:string="https://ikespzuzczfwsgjslszg.supabase.co";
    REACT_APP_SUPABASE_ANON_KEY:string="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlrZXNwenV6Y3pmd3NnanNsc3pnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjYyMjQ0OTgsImV4cCI6MjA0MTgwMDQ5OH0.qq7Dk3NdI4KhH0FZWtjRSMXIkcvpiOXGeVjM9zfj0jg";
}
export const supabaseKey = new SupabaseKey();